import { ReactComponent as FlagImportantIcon } from 'assets/icons/flag-important.svg';
import { ReactComponent as FlagLowIcon } from 'assets/icons/flag-low.svg';
import { ReactComponent as FlagNormalIcon } from 'assets/icons/flag-normal.svg';
import { ReactComponent as FlagUrgentIcon } from 'assets/icons/flag-urgent.svg';

import type ITaskPriorityOption from './interfaces/ITaskPriorityOption';

export const TASK_PRIORITY_VALUES = {
  URGENT: 'urgent',
  IMPORTANT: 'important',
  NORMAL: 'normal',
  LOW: 'low',
} as const;

export const TASK_PRIORITY_OPTIONS: ITaskPriorityOption[] = [
  {
    value: TASK_PRIORITY_VALUES.URGENT,
    label: 'Urgent',
    icon: <FlagUrgentIcon />,
  },
  {
    value: TASK_PRIORITY_VALUES.IMPORTANT,
    label: 'Important',
    icon: <FlagImportantIcon />,
  },
  {
    value: TASK_PRIORITY_VALUES.NORMAL,
    label: 'Normal',
    icon: <FlagNormalIcon />,
  },
  {
    value: TASK_PRIORITY_VALUES.LOW,
    label: 'Low',
    icon: <FlagLowIcon />,
  },
];

export const TASK_STATUS_REQUIRED_COMMENT = ['deferred', 'blocked', 'cancelled'];
